import { FjdBadge } from "fjd-react-components";

export interface MktBadgeProps {
  label: string;
}

export function MktBadge({ label }: MktBadgeProps) {
  return <FjdBadge label={label} appearance="secondary-dark" size="xs" />;
}
